import { Box, ButtonNew, ColorOptions, Icon, ImageNew, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { Link } from '@react-navigation/native'
import { FC, useEffect } from 'react'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { TextLayout } from '../../../comps/TextLayout'
import { useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { isSessionValid } from '../../../util/util'

const Status: FC = (props: any) => {
  const { updateActivation, initialized, resetAccessToken } = useStores((store) => ({
    updateActivation: store.agentQrConfig.updateActivation,
    resetAccessToken: store.agentQrSession.resetAccessToken,
    initialized: store.agentQrSession.initialized,
  }))
  const { route } = props
  const data = route?.params?.data ?? undefined
  console.log('===> data.vpa', data?.vpa)
  const { tr, ...displayData } = data
  const navigation = useNavigation()
  const keys = [data?.name ?? '']
  //   const values = Object.values(data)
  const status = route?.params?.status

  const isFocused = useIsFocused()

  useEffect(() => {
    if (status) {
      updateActivation(status === 'SUCCESS')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!initialized && isFocused) {
      if (navigation?.canGoBack()) {
        navigation.goBack()
      } else {
        const csoSessData = window.localStorage.getItem('csoSessData')
        console.log('csoSessData', csoSessData)
        if (csoSessData && csoSessData?.length > 0 && isSessionValid(csoSessData)) {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.midslist }],
          })
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.QrAgentLogin }],
          })
          resetAccessToken()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, navigation, resetAccessToken])

  const layouts = keys?.map((item: string, index: number) => {
    return <TextLayout title={item} data={displayData} key={item + index} />
  })

  const onClose = () => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: 'midslist',
        },
      ],
    })
  }

  const hrefUrl = `intent://#Intent;scheme=upi://pay?pa=${data?.vpa}&tr=${tr}&tn=Test_Transaction&am=1.00&cu=INR&pn=Jiopay%20Merchant;end`

  const sUsrAg = navigator.userAgent

  return (
    <Box f={1} padding={24} bg={'WHITE'}>
      <Box onPress={onClose} testID="close" marginRight={24} marginTop={18} underlayColor={'TRANSPARENT'}>
        <Icon color="BLUE" size={20} id="CLOSE" />
      </Box>
      <Spacer size={16} direction={'vertical'} />
      <Icon id={'SCAN_QR'} size={56} color={status === 'SUCCESS' ? 'GREEN' : 'BRAND_PRIMARY_RED'} />
      <Spacer size={24} direction={'vertical'} />
      <Text fontFamily="jiotype-black" fontSize={18} color={'BLACK_75'}>
        {status === 'SUCCESS' ? 'QR Activated Successfully' : 'QR Activation Failed'}
      </Text>
      <Spacer size={8} direction={'vertical'} />
      <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'}>
        {status === 'SUCCESS' ? 'Make a test transaction of ₹1 with any UPI App' : 'Please Try Again.'}
      </Text>
      <Spacer size={24} direction={'vertical'} />
      <ModBox flexDirection={'row'} show={status === 'SUCCESS'} alignItems={'center'}>
        <ImageNew source={require('../../../assets/images/all-in-one-qr/upiapps/jio.png')} height={24} width={24} />
        <Spacer size={8} direction={'horizontal'} />
        <ImageNew source={require('../../../assets/images/all-in-one-qr/upiapps/phonepe.png')} height={24} width={24} />
        <Spacer size={8} direction={'horizontal'} />
        <ImageNew source={require('../../../assets/images/all-in-one-qr/upiapps/gpay.png')} height={24} width={24} />
        <Spacer size={8} direction={'horizontal'} />
        <ImageNew source={require('../../../assets/images/all-in-one-qr/upiapps/paytm.png')} height={24} width={35} />
        <Spacer size={8} direction={'horizontal'} />
        <ImageNew source={require('../../../assets/images/all-in-one-qr/upiapps/amazon.png')} height={24} width={67} />
        <Spacer size={8} direction={'horizontal'} />
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'} title={'+ any UPI apps'} />
      </ModBox>
      <Spacer size={32} direction={'vertical'} />
      <ModBox
        alignItems={'center'}
        width={'100%'}
        f={1}
        height={48}
        marginBottom={32}
        show={sUsrAg.indexOf('Chrome') !== -1}>
        <Link to={status === 'SUCCESS' ? hrefUrl : '/agent/midslist'}>
          <ButtonNew
            color={'#0070B6' as ColorOptions}
            titleColor={'WHITE'}
            title={status === 'SUCCESS' ? 'Make test transaction of ₹1' : 'Retry QR Activation'}
            height={48}
            width={312}
            onPress={() => { }}
          />
        </Link>
      </ModBox>
      <Spacer size={32} direction={'vertical'} />
      <Box width={'100%'} h={8} bg={'#F0F0F0' as ColorOptions} />
      <Spacer size={32} direction={'vertical'} />
      {layouts}
    </Box>
  )
}

export { Status as default }
